import React, { ReactNode, useEffect, useState } from "react"
import { Alert, Badge, Button, Col, Form, FormControl, FormLabel, Modal, Row, Spinner } from "react-bootstrap"
import { PlusLg, Save, XLg } from "react-bootstrap-icons"
import { fetchApi } from "../../../Funciones"
import { useAuth } from "../../../Auth"
import latinize from "latinize";

export const TagSelector: React.FC<{ current: any[], onSelect: Function, newButton?: boolean, children: ReactNode }> = ({ current, onSelect, newButton, children }) => {
    let auth = useAuth();

    const [mostrar, setMostrar] = useState(false)
    const [filtro, setFiltro] = useState("")
    const [lista, setLista] = useState<any[]>([])
    const [tags, setTags] = useState<any[]>([])
    const [cargando, setCargando] = useState(false)

    const select = (tag: any) => {
        onSelect(tags)
    }

    const getData = async () => {
        setCargando(true)
        var resp = await fetchApi(auth.user.token, "tag", {
            cmd: "search",
            s: filtro,
            p: 0,
            pp: 200
        })
        setLista(resp.listado)
        setCargando(false)
    }
    useEffect(() => {
        if (auth.user && mostrar) {
            setTags(current)
            setFiltro("")
            getData()
        }
        // eslint-disable-next-line
    }, [auth.user, mostrar])

    var filtradas = lista.filter((tag: any) => {
        var show = false;

        if (filtro === "") {
            show = true
        }

        if (latinize(tag.name.toLowerCase()).includes(latinize(filtro.toLowerCase()))) {
            show = true
        }
        if (latinize(tag.description.toLowerCase()).includes(latinize(filtro.toLowerCase()))) {
            show = true
        }

        if (tags.filter((t: any) => t.id === tag.id).length > 0) {
            show = false;
        }
        return show
    });

    return <>
        <span onClick={() => setMostrar(!mostrar)}>{children}</span>
        <Modal show={mostrar} backdrop="static" onHide={() => setMostrar(false)} centered fullscreen={"sm-down"}>
            <Modal.Header closeButton><b>Etiquetas agregadas</b></Modal.Header>
            <Modal.Body className="pt-0">
                {tags.length > 0 && <TagList list={tags} onDelete={(tag: any) => {
                    setTags(tags.filter((t: any) => t.id !== tag.id))
                }} />}
                {tags.length === 0 && <Alert variant="info" className="py-0 w-auto d-inline-block">Aún no se han agregado etiquetas</Alert>}

                <hr />

                <h6 className="mt-2">Etiquetas disponibles</h6>
                <FormControl placeholder="Filtrar..." value={filtro} onChange={(ev) => setFiltro(ev.target.value)} className="mb-2" size="sm" />
                <div>
                    {cargando && <Spinner animation="border" />}
                    {!cargando && filtradas.length === 0 && <Alert variant="info" className="py-0 w-auto d-inline-block">Sin etiquetas disponibles</Alert>}
                    <TagList list={filtradas} onAdd={(tag: any) => { var t = [...tags, tag]; setTags(t); }} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                {newButton && <TagEditor id={""} name={""} description={""} backgroundColor={""} fontColor={""} callback={() => getData()}>
                    <Button size="sm" variant="secondary"><PlusLg /> Nueva Etiqueta</Button>
                </TagEditor>}
                <Button size="sm" variant="dark" onClick={() => { select(tags); setMostrar(false) }}><Save /> Guardar</Button>
                <Button size="sm" variant="danger" onClick={() => setMostrar(false)}><XLg /> Cancelar</Button>
            </Modal.Footer>
        </Modal>
    </>
}
export const TagEditor: React.FC<{ id: string, name: string, description: string, backgroundColor: string, fontColor: string, callback: Function, children: ReactNode }> = ({ id, name, description, backgroundColor, fontColor, callback, children }) => {
    let auth = useAuth()
    const [mostrar, setMostrar] = useState(false)
    const [cargando, setCargando] = useState(false)

    const [data, setData] = useState<any>({})
    const [error, setError] = useState("")
    const [guardado, setGuardado] = useState(false)
    const [estado, setEstado] = useState("")

    useEffect(() => {
        if (mostrar) {
            setData({
                id: id,
                name: name,
                backgroundColor: backgroundColor !== "" ? backgroundColor : "#555555",
                fontColor: fontColor !== "" ? fontColor : "#ffffff",
                description: description
            })
            setGuardado(id !== "")
            setError("")
            setEstado("")
        }
        // eslint-disable-next-line
    }, [mostrar])

    const change = (field: string, value: string) => {
        var d = { ...data }
        d[field] = value
        setData(d)
        setGuardado(false)
        setEstado("")
        setError("")
    }

    const submit = async (ev: any) => {
        ev.preventDefault()
        setCargando(true)
        var d = { ...data }
        d.cmd = "save"
        const resp = await fetchApi(auth.user.token, "tag", d)
        if (resp.estado === "ok") {
            d = { ...data }
            d.id = resp.id;
            setData(d)
            setGuardado(true)
            setError("")
            setEstado("Guardado correctamente.")
        }
        else {
            setError(resp.msg)
            setEstado("")
        }
        setCargando(false)
        return false;
    }

    const close = () => {
        setMostrar(false)
        callback()
    }

    return <>
        <span onClick={() => setMostrar(!mostrar)}>{children}</span>
        <Modal show={mostrar} backdrop="static" onHide={() => close()} size="sm" centered fullscreen={"sm-down"}>
            <Modal.Header closeButton>Editar Etiqueta</Modal.Header>
            <Modal.Body>
                <Form onSubmit={(ev) => submit(ev)}>
                    <div className="form-floating">
                        <FormControl id="name" type="text" placeholder="Nombre de la etiqueta" value={data.name + ""} onChange={(ev) => change("name", ev.target.value)} required />
                        <FormLabel htmlFor="name" className="text-primary fw-bold">Nombre de la etiqueta</FormLabel>
                    </div>
                    <div className="form-floating">
                        <FormControl id="desc" as="textarea" style={{ minHeight: 100 }} placeholder="Descripción" value={data.description} onChange={(ev) => change("description", ev.target.value)} />
                        <FormLabel htmlFor="desc" className="text-primary fw-bold">Descripción</FormLabel>
                    </div>
                    <Row className="mt-2">
                        <Col className="text-center">
                            Fuente: <br /><FormControl type="color" className="d-inline-block border-dark border" value={data.fontColor + ""} onChange={(ev) => change("fontColor", ev.target.value)} />
                        </Col>
                        <Col className="text-center">
                            Fondo: <br /><FormControl type="color" className="d-inline-block border-dark border" value={data.backgroundColor + ""} onChange={(ev) => change("backgroundColor", ev.target.value)} />
                        </Col>
                    </Row>
                    <div className="small muted mt-5">Vista Previa</div>
                    <div style={{ minHeight: 30 }}><Badge bg="" style={{ backgroundColor: data.backgroundColor, color: data.fontColor }}>{data.name}</Badge></div>

                    {!guardado && <Alert variant="warning">Datos sin guardar.</Alert>}
                    {error !== "" && <Alert variant="danger">{error}</Alert>}
                    {estado !== "" && <Alert variant="success">{estado}</Alert>}

                    <div className="text-center mt-5">
                        <Button variant="dark" size="sm" onClick={(ev) => submit(ev)} disabled={cargando || guardado || data.name === ""}><Save /> Guardar</Button>
                        <Button size="sm" variant="danger" onClick={() => close()} className="ms-2"><XLg /> Cancelar</Button>
                    </div>
                </Form>
                {cargando && <Spinner animation="border" />}
            </Modal.Body>
        </Modal>
    </>
}
export const TagList: React.FC<{ list: any[], onDelete?: Function, onAdd?: Function, separator?: ReactNode }> = ({ list, onDelete, onAdd, separator }) => {
    return <>
        {list.map((tag: any) => {
            if (onAdd) {
                return <React.Fragment key={tag.id}>
                    <Button title={tag.description} variant="outline-primary" size="sm" className="me-2 mb-2" style={{
                        backgroundColor: tag.backgroundColor,
                        color: tag.fontColor
                    }} onClick={() => onAdd(tag)}>{tag.name} <PlusLg /></Button>
                    {separator}
                </React.Fragment>
            }
            if (onDelete) {
                return <React.Fragment key={tag.id}>
                    <Button title={tag.description} variant="outline-primary" size="sm" className="me-2 mb-2" style={{
                        backgroundColor: tag.backgroundColor,
                        color: tag.fontColor
                    }} onClick={() => onDelete(tag)}>{tag.name} <XLg /></Button>
                    {separator}
                </React.Fragment>
            }
            return <React.Fragment key={tag.id}>
                <Badge title={tag.description} pill bg="" className="me-2 mb-2" style={{
                    backgroundColor: tag.backgroundColor,
                    color: tag.fontColor
                }}>{tag.name}</Badge>
                {separator}
            </React.Fragment>
        })}
    </>
}